export default (path, params={}) => {
    let _path = path;
    Object.keys(params).map(k => {
        _path = `${_path}`.replace(`:${k}`, params[k]);
    });
    return _path;
}